import { LazyLoadOnIdle } from '@ms/yammer-libs-lazy';
import Null from '@ms/yammer-libs-null';
import type { FC } from 'react';
import React from 'react';

const nonCriticalAPICallingFeatures = () =>
  import(/* webpackChunkName: "4-feat-deferred-app-shell" */ './NonCriticalAPICallingFeatures');
export const LoadableNonCriticalAPICallingFeatures: FC = () => (
  <LazyLoadOnIdle loader={nonCriticalAPICallingFeatures} Placeholder={Null} />
);
